module.exports = __webpack_public_path__ + "img/Wifi Icon - white.cf25d5c3.svg";